import React, { useEffect } from 'react'
import { privateRoutes } from '.'
import config from '../pages/Config'
import secureLocalStorage from 'react-secure-storage'
import { Navigate, Route, Routes } from 'react-router-dom'
import Index from '../pages/Dashboard/Index'
import Login from '../pages/Account/Login'
import { usePermissionData } from '../AppContext'
import PageNotFound from '../pages/PageNotFound'
import Unauthorized from '../pages/Unauthorized'

const ProtectedRoute = ({ component: Component, module_id, type }) => {
    const { checkAccess } = usePermissionData()
    const credential = secureLocalStorage.getItem("admin_credentials")

    if (!credential?.token || !credential?.email) {
        return <Navigate to={`${config.appUrl}login`} replace />
    }

    // If the route has a module_id, enforce view (type 1) or the specific type permission
    if (module_id && !checkAccess(module_id, type ?? 1)) {
        return <Navigate to={`${config.appUrl}unauthorized`} replace />
    }

    return <Component />
}

function AllRoutes() {
    const { loginStatus, setLoginStatus } = usePermissionData()
    const credential = secureLocalStorage.getItem("admin_credentials")

    useEffect(() => {
        if (credential)
            setLoginStatus(true)
    }, [])

    return <>
        <Routes>
            <Route path="*" Component={PageNotFound} />
            <Route path={`${config.appUrl}unauthorized`} Component={Unauthorized} />
            <Route path={`${config.appUrl}`} Component={Index} />
            <Route path={`${config.appUrl}login`} Component={Login} />

            {privateRoutes.map((route, index) => (
                <Route
                    key={index}
                    path={route?.path}
                    element={
                        <ProtectedRoute
                            component={route.component}
                            module_id={route.module_id}
                            type={route.type}
                        />
                    }
                />
            ))}
        </Routes>
    </>
}

export default AllRoutes;
